import { QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

type ErrorFromResponse = {
  message: string;
  error?: string;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (_failureCount, error) => {
        if (handleMfaError(error)) return false;
        if (isAxiosError(error) && error?.status === 401) {
          toast.error("Authorization failed, redirect into sign-in page");
          localStorage.removeItem("userId");
          localStorage.removeItem("companyType");
          window.location.href = "/sign-in";
          return false;
        }
        if (isAxiosError(error) && error?.status === 500) {
          toast.error("Server issue, try again later");
          return false;
        }
        return true;
      },
      retryDelay: 1000000000,
    },
    mutations: {
      onError(error) {
        if (isAxiosError(error)) {
          if (handleMfaError(error)) return;
          const responseData = error.response?.data as ErrorFromResponse;
          const errorMessage = responseData.message || "Something went wrong";
          if (error.status === 401) {
            localStorage.removeItem("userId");
            localStorage.removeItem("companyType");

            return (window.location.href = "/sign-in");
          }
          return toast.error(errorMessage);
        }
      },
    },
  },
});

const isAxiosError = (error: unknown): error is AxiosError => {
  return (error as AxiosError).isAxiosError !== undefined;
};

function handleMfaError(error: unknown): boolean {
  if (!isAxiosError(error) || error.response?.status !== 403) return false;
  const responseData = error.response.data as ErrorFromResponse | undefined;
  if (
    responseData?.error !== "mfa-required" &&
    responseData?.error !== "mfa-setup-required"
  ) {
    return false;
  }

  localStorage.removeItem("userId");
  localStorage.removeItem("companyType");
  window.location.href = "/sign-in";
  return true;
}

export default queryClient;
